import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <a
        href="https://www.flaticon.com/free-icons/georgia"
        title="georgia icons"
      >
        Georgia icons created by Roundicons - Flaticon
      </a>
      <a href="https://www.flaticon.com/free-icons/spain" title="spain icons">
        Spain icons created by Freepik - Flaticon
      </a>
      <a href="https://www.flaticon.com/free-icons/uk" title="uk icons">
        Uk icons created by Roundicons - Flaticon
      </a>
    </div>
  );
};

export default Footer;
